<div class="question-page">
    <bko-category-header
        [categoryIconUri]="categoryIconUri()"
        [categoryIconType]="categoryIconType()"
        [categoryTotal]="totalNumberOfCategories()"
        [categoryNumber]="currentCategoryNumber()"
        [categoryTitle]="categoryTitle()"
        [currentQuestion]="currentQuestionNumber()"
        [totalQuestions]="totalNumberOfQuestionsInCategory()"
    />
    <div class="hb-card question-card">
        <div class="card-content">
            <h2 class="hb-h2"> {{ questionText() }} </h2>
            @if (imageUri()) {
                <div class="image-container">
                    <img [src]="imageUri()" alt="" [class]="'image-' + imageType()">
                </div>
            }
            <p> {{ helpText() }} </p>
        </div>
        <div class="question-options">
            @switch (questionType()) {
                @case (SporsmalsType.Envalg) {
                    <bko-envalg-sporsmal
                        [alternatives]="alternatives()"
                        [form]="form()"
                    />
                }
                @case (SporsmalsType.Flervalg) {
                    <bko-flervalg-sporsmal
                        [alternatives]="alternatives()"
                        [form]="form()"
                    />
                }
            }
        </div>
        <div class="button-container">
            <button hb-button class="button-previous"
                    (click)="handlePreviousClick()">Forrige
            </button>
            <button hb-button class="button-next" [variant]="'PROMINENT'"
                    (click)="handleNextClick()">{{ nextButtonText() }}
            </button>

        </div>
    </div>

</div>
